import type { FaireProductEntity } from "../../entity_types/product";

export const p_92tfmnb4kg: FaireProductEntity = {
  token: "p_92tfmnb4kg",
  type: "product",
  name: "Protein Bar Sample Pack",
  brandName: "Aloha",
  imageUrl:
    "https://cdn.faire.com/fastly/2cd544db0ee89f280ee99562f3cc9c8c4123976534723b1a3588fe45a6deb1f2.jpeg",
  priceDollars: 29.58,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/203ce9845ff5329de92fc9be60297729580d427658bbe805fb4c8ed7748be5d4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
